/**
 * 所有接口变量都以 api开头，例如：apiGetUserInfo
 */
import { apiPost } from 'utils'
import { IHomeConfigInfoResponse, IHomeConfigPreviewResponse, INoticeInfoResponse, ISaveInfo, ISaveNotice } from 'model'
import { DropdownBox, XhhyBaseType, XhhyRequest, XhhyResponse } from 'Xhhy-common/common'

/**
 * 拉取首页设置信息
 * @param params
 */
export const apiSelectHomeConfigInfo = async (params: XhhyRequest) => {
  return await apiPost<XhhyRequest, IHomeConfigInfoResponse>(`/ticpocapi/homeconfig/selectHomeConfigInfo`, params)
}

/**
 * 拉取首页预览信息
 * @param params
 */
export const apiSelectHomePreviewInfo = async (params: XhhyRequest) => {
  return await apiPost<XhhyRequest, IHomeConfigPreviewResponse>(`/ticpocapi/homeconfig/selectHomePreviewInfo`, params)
}

/**
 * 保存首页信息
 * @param params
 */
export const apiHomeconfigSaveupdate = async (params: ISaveInfo) => {
  return await apiPost<ISaveInfo, XhhyResponse>(`/ticpocapi/homeconfig/saveupdate`, params)
}

/**
 * 发布首页信息
 * @param params
 */
export const apiRelease = async (params: ISaveInfo) => {
  return await apiPost<ISaveInfo, XhhyResponse>(`/ticpocapi/homeconfig/release`, params)
}

/**
 * 拉取公告信息
 * @param params
 */
export const apiNoticelists = async (params: XhhyRequest) => {
  return await apiPost<XhhyRequest, Array<INoticeInfoResponse>>(`/ticpocapi/homeconfig/noticelists`, params)
}

/**
 * 发布公告信息
 * @param params
 */
export const apiNoticerelease = async (params: Array<ISaveNotice>) => {
  return await apiPost<Array<ISaveNotice>, XhhyResponse>(`/ticpocapi/homeconfig/noticerelease`, params)
}

/**
 * 保存公告信息
 * @param params
 */
export const apiNoticesave = async (params: ISaveNotice) => {
  return await apiPost<ISaveNotice, XhhyResponse>(`/ticpocapi/homeconfig/noticesave`, params)
}

/**
 * 编辑公告信息
 * @param params
 */
 export const apiNoticeUpdate = async (params: ISaveNotice) => {
  return await apiPost<ISaveNotice, XhhyResponse>(`/ticpocapi/homeconfig/noticeupdate`, params)
}

/**
 * 模板下拉框
 * @param params
 */
 export const apiSelectTemplateComboBox = async (params: XhhyRequest) => {
  return await apiPost<XhhyRequest, Array<DropdownBox>>(`/ticpocapi/homeconfig/selectTemplateComboBox`, params)
}

/**
* 删除公告
* @param params
*/
export const apiNoticedelete = async (params: XhhyBaseType) => {
  return await apiPost<XhhyBaseType, XhhyResponse>(`/ticpocapi/homeconfig/noticedelete`, params)
}
